import React from 'react';
import PropTypes from 'prop-types';
import {
  FootnoteContent,
  FootnoteWrapper,
  FootnoteLink,
} from './ContentStyles';

const Footnote = ({ footnote }) => {
  if (!footnote) return null;

  const { css, messageCss, message, anchorUrl, anchorCss, anchorMessage } = footnote;
  return (
    <FootnoteWrapper css={css}>
      <FootnoteContent css={messageCss}>
        {message}
        <FootnoteLink
          href={anchorUrl}
          target="_self"
          css={anchorCss}
        >

          HERE
        </FootnoteLink>
        {anchorMessage}
      </FootnoteContent>
    </FootnoteWrapper>
  );
};

Footnote.propTypes = {
  footnote: PropTypes.shape({}),
};

Footnote.defaultProps = {
  footnote: null,
};

export default Footnote;
